export const poolName = {
    handsUp: "Поднять руки",
    handsUp1: "Руки вверх",
    salute: "Отдать честь 1",
    salute1: "Отдать честь 2",
    natMorPeh: "Наталья морская пехота",
    search: "Обыскать игрока",
    whistle: "Свистнуть",
    warmHands: "Греть руки",
    waiting: "Немного ожидания",
    press: "Упражнение на пресс",
    searchOnTheGround: "Ворочить землю",
    flapHends: "Махать руками",
    inspect: "Осмотреть",
    inspGround: "Осмотреть землю",
    pant: "Отдышка",
    pushUp: "Отжимания",
    kick: "Пнуть ногой",
    expect: "Задуматься",
    shrug: "Пожать плечами",
    showTwoFingers: "Показать два пальца",
    pointFinger: "Указать пальцем",
    putInMouth: "Положить что-то в рот",
    prayer: "Помолиться",
    drum: "Постучать",
    rubPalms: "Потереть ладони",
    rubPalms1: "Потереть ладони 2",
    rubNeck: "Потереть шею",
    rubAss: "Почесать попу",
    wash: "Мыться в душе",
    nervLookAround: "Нервно смотреть по сторонам",
    pickInHands: "Собирать в руках",
    waveFinger: "Помахать пальцем",
    tackleBelly: "Держаться за живот",
    tackleHeart: "Держаться за сердце",
    tss: "Тссс",
    lyingBlow: "Ударить по лежащему",
    washFace: "Умыться",
    transmitOnRadio: "Говорить в рацию",
    wrtPaper: "Запись на листочек",
    easyDance1: "Пританцовывать 1",
    easyDance2: "Пританцовывать 2",
    easyDance3: "Пританцовывать 3",
    easyDance4: "Пританцовывать 4",
    wrtNotebook: "Записать в блокнот",
    washFace1: "Умыться в озере",
    drinkCoffee: "Выпить кофе у стены",
    copInThrong: "Полиция в толпе",
    layBum: "Лежать как бомж",
    lean: "Опереться на перила",
    sitOnChair1: "Сесть на стул 1",
    sitOnChair2: "Сесть на стул 2",
    sitOnChair3: "Сесть на стул 3",
    sitOnChair4: "Сесть на стул 4",
    sitOnChair5: "Сесть на стул 5",
    sitOnChair6: "Сесть на стул 6",
    sitOnSofa: "Сесть на диван 1",
    expanding: "Распальцовка",
    handsToSide: "Расставить руки в стороны",
    handsFeetToSide: "Расставить руки и ноги в стороны",
    handsInSides: "Руки в боки",
    handsInSides1: "Руки в боки 2",
    foldHandsLookAround: "Скрестить руки и оглядываться",
    foldHands: "Скрестить руки",
    handsOverHead: "Руки за голову",
    handsOverBack: "Руки за спину",
    volchok: "Волчок",
    runInPlace: "Бег на месте",
    runInPlaceWaggle: "Бег на месте разводя руки",
    lieOnSide: "Лежать на боку",
    lieOnBelly: "Лежать на животе",
    lieOnBack1: "Лежать на спине 1",
    lieOnBack2: "Лежать на спине 2",
    lieOnBack3: "Лежать на спине 3",
    yoga: "Йога",
    posSecurity: "Поза охранника",
    showBiceps: "Показать бицепс",
    sit1: "Присесть 1",
    sit3: "Присесть 3",
    sit2: "Присесть 2",
    cryMercy: "Просить пощады",
    warmUp: "Размяться",
    foldHands2: "Скрестить руки",
    arnold: "Арнольд",
    standWall1: "Стойка у стены 1",
    standWall2: "Стойка у стены 2",
    standWall3: "Стойка у стены 3",
    standWall4: "Стойка у стены 4",
    standWall5: "Стойка у стены 5",
    standWall6: "Стойка у стены 6",
    standWall7: "Стойка у стены 7",
    standWall8: "Стойка у стены 8",
    chillGaz1: "Чилить на газоне 1",
    chillGaz2: "Чилить на газоне 2",
    chillGaz3: "Чилить на газоне 3",
    sunbathe: "Загарать на пляже",
    betterHand: "Я сильный, Вы слабые",
    waveHand: "Водить руками по воздуху",
    meditation: "Медитировать",
    chesatAss: "Чесать жопу",
    posSecurity2: "Поза охранника 2",
    fingUp: "Палец вверх",
    jumpHappy1: "Прыгать от счастья",
    jumpHappy2: "Прыгать от счастья 2",
    jumpHappy3: "Прыгать от счастья 3",
    gordSelf1: "Гордиться собой",
    gordSelf2: "Гордиться собой 2",
    uspokoit: "Успокоить",
    applause1: "Аплодировать 1",
    applause2: "Аплодировать 2",
    applause3: "Аплодировать 3",
    airkiss: "Воздушный поцелуй",
    kissPlayer: "Поцеловать игрока",
    bro: "Бро",
    fingersUp1: "Пальцы вверх 1",
    fingersUp2: "Пальцы вверх 2",
    jeeEst: "Жи есть",
    pickInNose: "Ковыряться в носу",
    refusal: "Отказ",
    skipHand: "Махнуть рукой",
    myatKulaki: "Мять кулаки",
    upset: "Огорчиться",
    krytitVisok: "Покрутить у виска",
    stupid: "Дурак",
    handFace: "Рука-лицо",
    shootingGun1: "Стрельба из пушек",
    shootingGun2: "Стрельба из ружья",
    baseball: "Бейсбол",
    stand: "Стойка",
    rage: "Злиться",
    showFuck: "Показать фак",
    facepalm: "Фейспалм",
    badger: "Дразнить",
    badger1: "Дразнить 1",
    badger2: "Дразнить 2",
    badger3: "Дразнить 3",
    ugrozhat: "Угрожать",
    krytitVisok2: "Крутить у виска",
    crazy: "Сходить с ума",
    stinks: "Воняет",
    whatTheHeck: "Какого черта?",
    dj: "DJ",
    easyDance15: "Пританцовывать",
    lesgin: "Лезгинка",
    hardBass: "Хард басы",
    twerk: "Тверк",
    clap: "Хлопать",
    dance1: "Танец 1",
    dance2: "Танец 2",
    dance3: "Танец 3",
    dance4: "Танец 4",
    dance5: "Танец 5",
    dance6: "Танец 6",
    dance7: "Танец 7",
    dance8: "Танец 8",
    dance9: "Танец 9",
    dance10: "Танец 10",
    dance11: "Танец 11",
    dance12: "Танец 12",
    dance13: "Танец 13",
    dance14: "Танец 14",
    dance15: "Танец 15",
    dance16: "Танец 16",
    dance17: "Танец 17",
    dance18: "Танец 18",
    dance19: "Танец 19",
    dance20: "Танец 20",
    dance21: "Танец 21",
    dance22: "Танец 22",
    dance23: "Танец 23",
    dance24: "Танец 24",
    dance25: "Танец 25",
    dance26: "Танец 26",
    dance27: "Танец 27",
    dance28: "Танец 28",
    dance29: "Танец 29",
    dance30: "Танец 30",
    dance31: "Танец 31",
    dance32: "Танец 32",
    dance33: "Танец 33",
    dance34: "Танец 34",
    dance35: "Танец 35",
    dance36: "Танец 36",
    dance37: "Танец 37",
    dance38: "Танец 38",
    dance39: "Танец 39",
    dance40: "Танец 40",
    stripDance1: "Стрип танец 1",
    stripDance2: "Стрип танец 2",
    stripDance3: "Стрип танец 3",
    stripDance4: "Стрип танец 4",
    stripDance5: "Стрип танец 5",
    stripDance6: "Стрип танец 6",
    stripDance7: "Стрип танец 7",
    stripDance8: "Стрип танец 8",
    stripDance9: "Стрип танец 9",
    stripDance10: "Стрип танец 10",
    stripDance11: "Стрип танец 11",
    stripDance12: "Стрип танец 12",
    stripDance13: "Стрип танец 13",
    guitarist: "Гитарист",
    kachatMyshtsy: "Качаться",
    chicken: "Курица",
    lomka: "Ломка",
    rock: "Рок",
    rock2: "Рок 2",
    waveHands: "Махать руками",
    karate: "Карате",
    sexMale1: "Секс мужчина 1",
    sexMale2: "Секс мужчина 2",
    sexMale3: "Секс мужчина 3",
    sexFemale1: "Секс женщина 1",
    sexFemale2: "Секс женщина 2",
    sexFemale3: "Секс женщина 3",
    pullHands: "Дергать руками",
    trup: "Труп",
    photographer: "Фотограф",
    BlindingLights: "Blinding Lights",
    BoogieDown: "Boogie Down",
    KneeSlapper: "Knee Slapper",
    Crossbounce: "Crossbounce",
    DiscoFever: "Disco Fever",
    DontStartNow: "Dont Start Now",
    Floss: "Floss",
    Fresh: "Fresh",
    GangnamStyle: "Gangnam Style",
    HeartRizon: "Heart Rizon",
    JabbaSwitchway: "Jabba Switchway",
    TheMacarena: "The Macarena",
    LastForever: "Last Forever",
    RideThePony: "Ride The Pony",
    Rollie: "Rollie",
    SaySo: "Say So",
    SignatureShuffle: "Signature Shuffle",
    SquatKick: "Squat Kick",
    StepItUp: "Step It Up",
    TheFlow: "The Flow",
    TheRenegade: "The Renegade",
    Stuck: "Stuck",
    PumpUpTheJam: "Pump Up The Jam",
    Socks: "Socks",
    MyWorld: "My World",
    WakeUp: "Wake Up",
    OndaOnda: "Onda Onda",
    GetGriddy: "Get Griddy",
    HitIt: "Hit It",
    LeaveTheDoorOpen: "Leave The Door Open",
    ChickenWingIt: "Chicken Wing It",
    Savage: "Savage",
    ElectroSwing: "Electro Swing",
    Sprinkler: "Sprinkler",
    Smeeze: "Smeeze",
    GoMufasa: "GoMufasa",
    HeyNow: "Hey Now",
    BuildUp: "Build Up",
    Breakdown: "Breakdown",
    TakeTheL: "Take The L",
    IAintAfraid: "I Aint Afraid",
    GetGone: "Get Gone",
    MaximumBounce: "Maximum Bounce",
    ILikeToMoveIt: "I Like To Move It",
    LeiltElomr: "Leilt Elomr",
    Tidy: "Tidy",
    BhangraBoogie: "Bhangra Boogie",
    OutWest: "Out West",
    ToosieSlide: "Toosie Slide",
    PullUp: "Pull Up",
    TheCraneKick: "The Crane Kick",
    BillyBounce: "Billy Bounce",
    ElectroShuffle: "Electro Shuffle",
    WorkItOut: "Work It Out",
    Zany: "Zany",
    SmoothMoves: "Smooth Moves",
    Vivacious: "Vivacious",
    Hula: "Hula",
    TrueHeart: "True Heart",
    Reanimated: "Reanimated",
    InDaParty: "In Da Party",
    BimBamBoom: "Bim Bam Boom",
    WannaSeeMe: "Wanna See Me",
    DynamicShuffle: "Dynamic Shuffle",
    NeverGonna: "Never Gonna",
    FrightFunk: "Fright Funk",
    Jitterbug: "Jitterbug",
    Infectious: "Infectious",
    WhereIsMatt: "Where Is Matt?",
    SavorTheW: "Savor The W",
    DanceTherapy: "Dance Therapy",
    Intensity: "Intensity",
    RushinAround: "Rushi'n Around",
    AdvancedMath: "Advanced Math",
    BoldStance: "Bold Stance",
    Freemix: "Freemix",
    Extraterrestrial: "Extraterrestrial",
    Crabby: "Crabby",
    Lavish: "Lavish",
    MimeTime: "Mime Time",
    TaiChi: "Tai Chi",
    LilBounce: "Lil Bounce",
    Daydream: "Daydream",
    WorkIt: "Work It",
    Slick: "Slick",
    Bombastic: "Bombastic",
    ItsaVibe: "It's a Vibe",
    WuTangIsForever: "Wu-Tang Is Forever",
    RootinTootin: "Rootin' Tootin",
    Triumphant: "Triumphant",
    LilDiplodoculus: "Lil Diplodoculus",
    Frolic: "Frolic",
    PhoneItIn: "Phone It In",
    LlamaBell: "Llama Bell",
    MajesticCoinFlip: "Majestic Coin Flip",
    LilFloaticorn: "Lil Floaticorn",
    Glowsticks: "Glowsticks",
    ShakeItUp: "Shake It Up",
    IslandVibes: "Island Vibes",
    SnareSolo: "Snare Solo",
    RockOut: "Rock Out",
    LilOctane: "Lil Octane",
    Unicycle: "Unicycle",
    BloominBouquet: "Bloomin Bouquet",
    LilMonster: "Lil Monster",
    GuitarWalk: "Guitar Walk",
    BestMates: "Best Mates",
    OnYourMarks: "On Your Marks",
    LaidBackShuffle: "Laid Back Shuffle",
    ThePolloDance: "The Pollo Dance",
    Scenario: "Scenario",
    BuckleUp: "Buckle Up",
    ItsComplicated: "Its Complicated",
    FreedomWheels: "Freedom Wheels",
    EverybodyLovesMe: "Everybody Loves Me",
    Pirouette: "Pirouette",
    LazerBlast: "Lazer Blast",
    Poki: "Poki",
    Leapin: "Leapin",
    WellRounded: "Well Rounded",
    Flux: "Flux",
    Whirlwind: "Whirlwind",
    Jamboree: "Jamboree",
    SlapHappy: "Slap Happy",
    DreamFeet: "Dream Feet",
    Switchstep: "Switchstep",
    Glitter: "Glitter",
    SugarRush: "Sugar Rush",
    Twist: "Twist",
    Howl: "Howl",
    CrazyFeet: "Crazy Feet",
    HotMarat: "Hot Marat",
    ShowStopper: "Show Stopper",
    Boneless: "Boneless",
    PopLock: "Pop Lock",
    Steady: "Steady",
    Shimmer: "Shimmer",
    Springy: "Springy",
    FreeFlow: "Free Flow",
    Conga: "Conga",
    DeepEnd: "Deep End",
    Pumpernickel: "Pumpernickel",
    Jubilation: "Jubilation",
    Jaywalking: "Jaywalking",
    PeaceOut: "Peace Out",
    Hype: "Hype",
    OrangeJustice: "Orange Justice",
    SwipeIt: "Swipe It",
    JumpAround: "Jump Around",
    MonsterMash: "Monster Mash",
    FeelTheFlow: "Feel The Flow",
    Copines: "Copines",
    JiggleJiggle: "Jiggle Jiggle",
    ForgetMeNot: "Forget Me Not",
    DrippinFlavor: "Drippin Flavor",
    Distraction: "Distraction",
    UCantCMe: "U Cant C Me",
    TacoTime: "Taco Time",
    Snowshaker: "Snowshaker",
    RideAlong: "Ride Along",
    SingAlong: "Sing Along",
    Unwrapped: "Unwrapped",
    DoubleUp: "Double Up",
    Sway: "Sway",
    ItsDynamite: "Its Dynamite",
    MaYaHi: "Ma Ya Hi",
    JugBand: "Jug Band",
    GetSchwifty: "Get Schwifty",
    ShantyForASquad: "Shanty For A Squad",
    LilPrancer: "Lil Prancer",
    SlalomStyle: "Slalom Style",
    SideShuffle: "Side Shuffle",
    Flapper: "Flapper",
    Vibin: "Vibin",
    TheRobot: "The Robot",
    GrooveJam: "Groove Jam",
    Flamenco: "Flamenco",
    TheRickDance: "The Rick Dance",
    Crackdown: "Crackdown",
    PrimoMoves: "Primo Moves",
    Balletic: "Balletic",
    InfiniteDab: "Infinite Dab",
    HandSignals: "Hand Signals",
    FancyFeet: "Fancy Feet",
    CleanGroove: "Clean Groove",
    OldSchool: "Old School",
    Intdroducing: "Intdroducing",
    SkaStraTerrestrial: "Ska Stra Terrestrial",
    YoureAwesome: "Youre Awesome",
    CluckStrut: "Cluck Strut",
    Slitherin: "Slitherin",
    ItsGoTime: "Its Go Time",
    GetFunky: "Get Funky",
    NanaNana: "Nana Nana",
    SideHustle: "Side Hustle",
    Droop: "Droop",
    MashedPotato: "Mashed Potato",
    Verve: "Verve",
    Gloss: "Gloss",
    MyIdol: "MyIdol",
    PawsClaws: "Paws Claws",
    RunningMan: "Running Man",
    LivingLarge: "Living Large",
    Hootenanny: "Hootenanny",
    DirtbikeChallenge: "Dirtbike Challenge",
    LunarParty: "Lunar Party",
    TheLook: "The Look",
    Revel: "Revel",
    ImDiamond: "Im Diamond",
    Hitchhiker: "Hitchhiker",
    Waterworks: "Waterworks",
    PickItUp: "Pick It Up",
    CaliforniaGurls: "California Gurls",
    BBoomBBoom: "BBoom BBoom",
    HangLooseCelebration: "Hang Loose Celebration",
    Tootsee: "Tootsee",
    TheDanceLaroi: "The Dance Laroi",
    DanceOff: "Dance Off",
    FishyFlourish: "Fishy Flourish",
    Freestylin: "Freestylin",
    Glyphic: "Glyphic",
    Fandangle: "Fandangle",
    MarshWalk: "Marsh Walk",
    LazyShuffle: "Lazy Shuffle",
    Backstroke: "Backstroke",
    CrissCross: "Criss Cross",
    PartyHips: "Party Hips",
    LlamaConga: "Llama Conga",
    JumpingJacks: "Jumping Jacks",
    Shout: "Shout",
    Yay: "Yay",
    Forever: "Forever",
    TheMagicBomb: "The Magic Bomb",
    RollNRock: "Roll n Rock",
    WarmUp: "Warm Up",
    GunslingerSmokeshow: "Gunslinger Smokeshow",
    SweetShot: "Sweet Shot",
    VibrantVibin: "Vibrant Vibin",
    KoiDance: "Koi Dance",
    TheQuickStyle: "The Quick Style",
    MadeYouLook: "Made You Look",
    AskMe: "Ask Me",
    Komarovo: "Komarovo",
    Sleds: "Sleds",
    RingItOn: "Ring It On",
    Boomin: "Boomin",
    BootsNCats: "Boots n Cats",
    Rage: "Rage",
    IDeclare: "I Declare",
    RocketRodeo: "Rocket Rodeo",
    DrumMajor: "Drum Major",
    PumpItUp: "Pump It Up",
    CheerUp: "Cheer Up",
    EmpressFanDance: "Empress Fan Dance",
    ManeraMir: "Manera Mir",
    AirShredder: "Air Shredder",
    CrazyBoy: "Crazy Boy",
    Fishin: "Fishin",
    NinjaStyle: "Ninja Style",
    TheWorm: "The Worm",
    Wiggle: "Wiggle",
    StarPower: "Star Power",
    Rambunctious: "Rambunctious",
    Rawr: "Rawr",
    FastFeet: "Fast Feet",
    Capoeira: "Capoeira",
    Bobbin: "Bobbin",
    Overdrive: "Overdrive",
    Fanciful: "Fanciful",
    BunnyHop: "Bunny Hop",
    NoSweat: "No Sweat",
    WindmillFloss: "Windmill Floss",
    SwoleCat: "Swole Cat",
    HeadBanger: "Head Banger",
    GetLoose: "Get Loose",
    Bully: "Bully",
    BringItAround: "Bring It Around",
    SquareUp: "Square Up",
    WithoutYou: "Without You",
    RunItDown: "Run It Down",
    Goated: "Goated",
    CelebrateMe: "Celebrate Me",
    PayItOff: "Pay It Off",
    FastFlex: "Fast Flex",
    GetOutOfYourMind: "Get Out of Your Mind",
    LitDance: "Lit Dance",
    TakeTheElf: "Take The Elf",
    SnowDay: "Snow Day",
    ChoiceKnit: "Choice Knit",
    ShaolinSip: "Shaolin Sip",
    LilTreat: "Lil Treat",
    Sparkler: "Sparkler",
    TelekenetikCookies: "Telekinetic Cookies",
    TangerineJuggling: "Tangerine Juggling",
    HeartAttach: "Heart Attach",
    OmgILoveIt: "Omg I Love It",
    HeartSign: "Heart Sign",
    DanceMonkey: "Dance Monkey",
    KissKiss: "Kiss Kiss",
    PonyUp: "Pony Up",
    "9mmGoBang": "9mm Go Bang",
    Starlit: "Starlit",
    JustWannaRock: "Just Wanna Rock",
    BadGuy: "Bad Guy",
    KeepEmCrispy: "Keep Em Crispy",
    EvilPlan: "Evil Plan",
    JubiSlide: "Jubi Slide",
    DomDomYesYes: "Dom Dom Yes Yes",
    PlanetaryVibe: "Planetary Vibe",
    PumpMeUp: "Pump Me Up",
    Headbanger2: "Headbanger 2",
    CultureFestival: "Culture Festival",
    BustAMove: "Bust A Move",
    BoysALiar: "Boys A Liar",
    Bizcochito: "Bizcochito",
    NightOut: "Night Out",
    StartItUp: "Start It Up",
    WindUp: "Wind Up",
    IJustWannaDance: "I Just Wanna Dance",
    CalledShot: "Called Shot",
    WitchWay: "Witch Way",
    Cardistry: "Cardistry",
    TargetTraining: "Target Training",
    SproutOfTune: "Sprout Of Tune",
    ClickClickFlash: "Click Click Flash",
    Ambitious: "Ambitious",
    BoneyBounce: "Boney Bounce",
    BoodUpGroove: "Bood Up Groove",
    Carefree: "Carefree",
    Classy: "Classy",
    DancinDomino: "Dancin Domino",
    GoWithTheFlow: "Go With The Flow",
    Hooray: "Hooray",
    MakeSomeWaves: "Make Some Waves",
    NoCure: "No Cure",
    PopularVibe: "Popular Vibe",
    RainCheck: "Rain Check",
    RealSlimShady: "Real Slim Shady",
    Rebellious: "Rebellious",
    ShowYa: "Show Ya",
    SocialClimber: "Social Climber",
    SwagShuffle: "Swag Shuffle",
    TheSquabble: "The Squabble",
    ToTheBeat: "To The Beat",
    YouAWinner: "You A Winner",
    YouShouldSeeMeInACrown: "You Should See Me In A Crown",
    BounceWitIt: "Bounce Wit It",
    Expressionism: "Expressionism",
    SqueezieDoesIt: "Squeezie Does It",
    LilSupercar: "Lil Supercar",
    Squirrelly: "Squirrelly",
    ZoidbergScuttle: "Zoidberg Scuttle",
    GGWP: "GGWP",
    Baller: "Baller",
    LiveFromHaddonfield: "Live From Haddonfield",
    ItIsATrick: "It Is A Trick",
    MiracleTrickshot: "Miracle Trickshot",
    ReaperShowtime: "Reaper Showtime",
    Pickin: "Pickin",
    PilaTricycle: "Pila Tricycle",
    PrisonerMugshotM: "Prisoner Mugshot",
    PrisonerMugshotF: "Prisoner Mugshot",
    SamuraiStrike: "Samurai Strike",
    KiotoFan: "Kioto Fan",
    RonaldGreeting: "Ronald Greeting",
    Snowflakey: "Snow Flakey",
    ToysFlip: "Toys Flip",
    IceMoves: "Ice Moves",
    TeaTime: "Tea Time",
    CompanyJig: "Company Jig",
    Boing: "Boing",
    WhatYouWant: "What You Want",
    CloudSwing: "Cloud Swing",
    PointAndStrut: "Point And Strut",
    Breakneck: "Breakneck",
    DeerCadabra: "Deer Cadabra",
    NoTears: "No Tears",
    HeartbreakShuffle: "Heartbreak Shuffle",
    Entranced: "Entranced",
    Caffeinated: "Caffeinated",
    ByeByeBye: "Bye Bye Bye",
    PickMeUp: "Pick Me Up",
    Airboard: "Airboard",
    Desirable: "Desirable",
    Puffer: "Puffer",
    ChuggaChugga: "Chugga Chugga",
    MoneyBlastin: "Money Blastin",
    DarkDiscount: "overdose",
    GorillaDance: "gorilla",
    HeartAttach: "Heart Attach",
    OmgILoveIt: "Omg I Love It",
    PlanetaryVibe: "Planetary Vibe",
    PumpMeUp: "Pump Me Up",
    Headbanger2: "Headbanger 2",
    CultureFestival: "Culture Festival",
    BustAMove: "Bust A Move",
    BoysALiar: "Boys A Liar",
    Bizcochito: "Bizcochito",
    NightOut: "Night Out",
    StartItUp: "Start It Up",
    WindUp: "Wind Up",
    Starlit: "Starlit",
    DomDomYesYes: "Dom Dom Yes Yes",
    IJustWannaDance: "I Just Wanna Dance",
    CalledShot: "Called Shot",
    WitchWay: "Witch Way",
    Cardistry: "Cardistry",
    TargetTraining: "Target Training",
    KeepEmCrispy: "Keep Em Crispy",
    SproutOfTune: "Sprout Of Tune",
    ClickClickFlash: "Click Click Flash",
    PonyUp: "Pony Up",
    KissKiss: "Kiss Kiss",
    HeartSign: "Heart Sign",
    Ambitious: "Ambitious",
    BadGuy: "Bad Guy",
    BoneyBounce: "Boney Bounce",
    BoodUpGroove: "Bood Up Groove",
    Carefree: "Carefree",
    Classy: "Classy",
    DancinDomino: "Dancin Domino",
    EvilPlan: "Evil Plan",
    GoWithTheFlow: "Go With The Flow",
    Hooray: "Hooray",
    MakeSomeWaves: "Make Some Waves",
    NoCure: "No Cure",
    PopularVibe: "Popular Vibe",
    RainCheck: "Rain Check",
    RealSlimShady: "Real Slim Shady",
    Rebellious: "Rebellious",
    ShowYa: "Show Ya",
    SwagShuffle: "Swag Shuffle",
    TheSquabble: "The Squabble",
    ToTheBeat: "To The Beat",
    YouAWinner: "You A Winner",
    YouShouldSeeMeInACrown: "You Should See Me In A Crown",
    JustWannaRock: "Just Wanna Rock",
    _9mmGoBang: "9mm Go Bang",
    Expressionism: "Expressionism",
    SqueezieDoesIt: "Squeezie Does It",
    LilSupercar: "Lil Supercar",
    Squirrelly: "Squirrelly",
    ZoidbergScuttle: "Zoidberg Scuttle",
    GGWP: "GGWP",
    Baller: "Baller",
    LookingToTheSky: "Looking To The Sky",
    LiveFromHaddonfield: "Live From Haddonfield",
    ItIsATrick: "It Is A Trick",
    MiracleTrickshot: "Miracle Trickshot",
    ReaperShowtime: "Reaper Showtime",
    Pickin: "Pickin",
    PilaTricycle: "Pila Tricycle",
    PrisonerMugshotM: "Prisoner Mugshot M",
    PrisonerMugshotF: "Prisoner Mugshot F",
    SamuraiStrike: "Samurai Strike",
    KiotoFan: "Kioto Fan",
    RonaldGreeting: "Ronald Greeting",
    PickMeUp: "Pick Me Up",
    IceMoves: "Ice Moves",
    Snowflakey: "Snowflakey",
    ChuggaChugga: "Chugga Chugga",
    MoneyBlastin: "Money Blastin",
    Airboard: "Airboard",
    ToysFlip: "Toys Flip",
    DeerCadabra: "Deer Cadabra",
    Boing: "Boing",
    ByeByeBye: "Bye Bye Bye",
    Caffeinated: "Caffeinated",
    Desirable: "Desirable",
    WhatYouWant: "What You Want",
    Entranced: "Entranced",
    CompanyJig: "Company Jig",
    PointAndStrut: "Point And Strut",
    Breakneck: "Breakneck",
    NoTears: "No Tears",
    BriteMoves: "Brite Moves",
    WaddleAway: "Waddle Away",
    GiftDrop: "Gift Drop",
    SantaLaughing: "Santa Laughing",
    XOXO: "XOXO",
    DonkeyFlight: "Donkey Flight",
    AlaskaPuffer: "Alaska Puffer",
    NyaArigato: "Nya Arigato",
    Shine: "Shine",
    ExumShuffle: "Exum Shuffle",
    LemonMelonCoockie: "Lemon Melon Coockie",
    SurfinBird: "Surfin Bird",
    DeepExplorer: "Deep Explorer",
    Smitten: "Smitten",
    Commited: "Commited",
    RibbonDancer: "Ribbon Dancer",
    AmazingCube: "Amazing Cube",
    ASMRKeys: "ASMR Keys",
    CupidArrow: "Cupid Arrow",
    Accolades: "Accolades",
    DillWithIt: "Dill With It",
    Popcorn: "Popcorn",
    Surrender: "Surrender",
    JumpRopeJig: "Jump Rope Jig",
    TickTock: "Tick Tock",
    ShareTheWealth: "Share The Wealth",
    CoinRain: "Coin Rain",
    Ballsy: "Ballsy",
    LightWeight: "Light Weight",
    Target: "Target",
    TornadoSpin: "Tornado Spin",
    KickUps: "Kick Ups",
    CleansingFlame: "Cleansing Flame",
    CloseToYou: "Close To You",
    Attraction: "Attraction",
    CaliforniaLove: "California Love",
    Dimensional: "Dimensional",
    KeepMeSatisfied: "Keep Me Satisfied",
    Click: "Click",
    LovelySigns: "Lovely Signs",
    Pokedance: "Pokedance",
    Doodle: "Doodle",
    CrankItUp: "Crank It Up",
    Anxiety: "Anxiety",
    APT: "APT",
    WaitChallenge: "Wait Challenge",
    PassoBemSolto: "Passo Bem Solto",
    LezginkaSuper: "Lezginka Super",
    Lambada: "Lambada",
    DieWithASmile: "Die With A Smile",
    MagicCards: "Magic Cards",
    ServeStance: "Serve Stance",
    PaddleRoyale: "Paddle Royale",
    AFK: "AFK",
    Super: "Super",
    NewsVan: "News Van",
    DronePapped: "Drone Papped",
    SideStep: "Side Step",
    CheChe: "Che Che",
    SwagSurfin: "Swag Surfin",
    Disco: "Disco",
    ConfessYourLove: "Confess Your Love",
    DiaDelica: "Dia Delica",
    KillinItGirl: "Killin It Girl",
    Limits: "Limits",
    Mutt: "Mutt",
    RockYourBody: "Rock Your Body",
    AuraFarming: "Aura Farming",
    Marabu: "Marabu",
    LezginkaTwirl: "Lezginka Twirl",
    OctopusBackflip: "Octopus Backflip",
    OctopusStand: "Octopus Stand",
    BullyMaguire: "Bully Maguire",
    SUI: "SUI",
    Scarewow: "Scarewow",
    GhostRider: "Ghost Rider",
    LilUfo: "Lil Ufo",
    Chainsaw: "Chainsaw",
    BooBox: "Boo Box",
    KnifeInspect: "Knife Inspect",
    TerrifierBox: "Terrifier Box",
    Mwahaha: "Mwahaha",
    SquidGame: "Squid Game",
    Wednesday: "Wednesday",
    SugarTongue: "Sugar Tongue",
    SurvivorNurse: "Survivor Nurse",
    CoffeeHand: "Coffee Hand",
    ThePiper: "The Piper",
    FrozenHorse: "Frozen Horse",
    SantaSnowglobe: "Santa Snowglobe",
    NiceLust: "Nice Lust",
    SnowBunny: "Snow Bunny",
    LootFlex: "Loot Flex",
    BowGo: "Bow Go",
    FireworkRider: "Firework Rider",
    Snowracer: "Snowracer",
    SparklerDrums: "Sparkler Drums",
    EmojiLove: "Emoji Love",
    EmojiClown: "Emoji Clown",
    Cliche: "Cliche",
    Song2: "Song 2",
    Two: "Two",
    GetLucky: "Get Lucky",
    DreamStance: "Dream Stance",
    Mystical: "Mystical",
    LoveGame: "Love Game",
    NewJeans: "New Jeans",
    CountryBells: "Country Bells",
    TurnUp: "Turn Up",
    DeerSleigh: "Deer Sleigh",
    Pocoyo: "Pocoyo"

}

export const getName = (key) => {
    return poolName[`${key.replace("animations.list.", "")}`] || key;
}